// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".o-Adv-block[data-v-cb6bc9d4]{padding-top:0}\n", ""]);
// Exports
module.exports = exports;
